import {PIXI} from '@colonist/pixi'
import {UIGameEndTableView} from './GameEndTableView'
import {EndGameStateUtils} from '@colonist/game-endgame-types'
import {EndGameData, VictoryPointStateReader} from '@colonist/game-base-types'
import {EndGameState} from '@colonist/game-states'

export class GameEndStatsActivityStatsView extends UIGameEndTableView {
    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, columnWidth: number, rowHeight: number, endGameState: EndGameState) {
        super(x, y, w, h, container, columnWidth, rowHeight)

        const players = EndGameStateUtils.getPlayersSortedByRank(endGameState.players)
        const points: EndGameData[][] = []
        for(const player of players) {
            const data: EndGameData[] = []
            const playerVP = VictoryPointStateReader.totalPrivateVictoryPoints(player.victoryPoints)
            const playerActivityStats = endGameState.activityStats[player.color]
            if(playerActivityStats === undefined) continue
            data.push({amount: playerVP, highest: false})
            data.push({amount: playerActivityStats.proposedTrades, highest: false})
            data.push({amount: playerActivityStats.successfulTrades, highest: false})
            data.push({amount: playerActivityStats.resourcesUsed, highest: false})
            data.push({amount: playerActivityStats.resourceIncomeBlocked, highest: false})
            data.push({amount: playerActivityStats.devCardsBought, highest: false})
            data.push({amount: playerActivityStats.devCardsUsed, highest: false})
            points.push(data)
        }

        this.createPoints(points)
    }
}
